module.exports = __webpack_public_path__ + "img/oyster_shell.6af3b332.jpg";